import styled from 'styled-components';
import Text from 'v3/components/Text';
import Link from 'v3/components/Link';
import Badge from 'v3/components/Badge';

export const LinkTo = styled(Link)`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`;

export const AccessContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  min-height: 61px;
  padding: 10px 0;
  scrollbar-width: thin;

  & > * {
    flex: 0 0 auto;
  }
`;

export const ButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
`;

export const Title = styled(Text)`
  font-weight: bold;
  font-size: 12px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: -3px;
`;

export const BadgeLink = styled(Badge)`
  transition: 0.5s;
  border-radius: 6px !important;
  padding: 7px 12px !important;
  &:hover {
    background-color: #e1e1e1 !important;
  }
`;
